<template>
  <v-card>
    <v-card-title>
      Nutrition
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        v-bind:search="search"
        v-bind:pagination.sync="pagination"
        v-bind:total-items="pagination.totalItems"
      >
      <template slot="items" scope="props">
       
        
        <td class="text-xs-right">{{ props.item.project.name }}</td>
        <td class="text-xs-right">{{ props.item.task.name }}</td>
         <td class="text-xs-right">{{ props.item.user.name }}</td>
         <td class="text-xs-right">{{ props.item.spent_date }}</td>
        <td class="text-xs-right">{{ props.item.client.name }}</td>
        <td class="text-xs-right"><v-icon  v-if="props.item.billable" color="grey">trending_up</v-icon><v-icon v-if="!props.item.billable" color="grey">trending_flat</v-icon></td>
        <td class="text-xs-right"><v-progress-circular v-if="props.item.is_running" indeterminate color="grey"></v-progress-circular></td>
        <td class="text-xs-right">{{ props.item.notes }}</td>
         <td class="text-xs-right"> {{ props.item.hours }}</td>
      </template>
      <template slot="pageText" scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
  </v-card>
</template>




<script>
  export default {
    props:['data'],
    data () {
      return {
        max25chars: (v) => v.length <= 25 || 'Input too long!',
        tmp: '',
        search: '',
        pagination: {
          rowsPerPage:10
        },
        headers: [
          {
            text: 'Project',
            align: 'left',
            sortable: false,
            value: 'project.name'
          },
          { text: 'Task', value: 'task.name' },
          { text: 'User', value: 'user.name' },
          { text: 'Spent Date', value: 'spent_date' },
          
          { text: 'Client', value: 'client.name' },
          { text: 'Billable', value: 'billable' },
          { text: 'Is Running', value: 'is_running' },
          { text: 'Notes', value: 'notes' },
          { text: 'Hours', value: 'hours' }

               




        ],
        items: []
      }
    },
    watch:{
        data: function(newValue){
            console.log('newValue')
            this.items =newValue.time_entries;
            this.pagination = {
                page: newValue.page,
                rowsPerPage: newValue.per_page,
                totalItems: newValue.total_entries
            }
          
        },
        pagination: function(newValue, oldValue) {
            console.log('pagination', newValue)
            if (!oldValue || (oldValue.page == newValue.page &&
                    oldValue.rowsPerPage == newValue.rowsPerPage))
                return;
            this.$emit('change', {
                page: newValue.page,
                per_page: newValue.rowsPerPage
            });
        }
    },
    created(){
        console.log('this.data',this.data)
        console.log('this.data', this.data)
            this.items = this.data.time_entries;
           
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/Admin/TimeSheets/TimeSheetsTable.vue